<template lang="pug" src="./html/MainNavStage.pug"></template>

<script>

  import EventBus from './../event-bus'
  import SiteStructure from './tools/site-structure'

  const emptySubNav = {}

  export default {
    beforeCreate () {
      this._data = {
        navSelected: null,
        navPrev: emptySubNav,
        navNext: emptySubNav,
        navList: SiteStructure.getNavTree().list
      }
    },
    mounted () {
      let vm = this
      EventBus.$on('Nav.CHANGE', function (e) {
        vm.navUpdated(e.navItem)
      })
      this.navUpdated(SiteStructure.getSelectedItem())
    },
    methods: {
      navUpdated (navItem) {
        if (navItem) {
          if (navItem.depth === 0) {
            this._data.navSelected = navItem
            this._data.navPrev = emptySubNav
            this._data.navNext = emptySubNav
          } else if (navItem.depth === 1) {
            this._data.navSelected = navItem.getRootParent()
            let tree = SiteStructure.getSelectedTree()
            let prevItem = tree.list[navItem.index - 1]
            let nextItem = tree.list[navItem.index + 1]
            if (!prevItem) {
              prevItem = emptySubNav
            }
            if (!nextItem) {
              nextItem = emptySubNav
            }
            this._data.navPrev = prevItem
            this._data.navNext = nextItem
          }
        } else {
          this._data.navSelected = null
        }
      },
      a: SiteStructure.a
    },
    data () {
      return this._data
    }
  }
</script>

<style scoped lang="sass" src="./style/MainNavStage.sass"></style>
